import { CarePlanBranch, CarePlanStep } from "../types";
import { createContext, useContext } from "react";
interface DecisionStepState {
  decisionStep: CarePlanStep;
  branches: CarePlanBranch[];
  selectedBranchId: string | null;
  isResolved: boolean;
}
interface DecisionStepActions {
  selectBranch?: (branchId: string) => Promise<void>;
  addBranch: () => void;
}
export interface DecisionStepContextValue {
  state: DecisionStepState;
  actions: DecisionStepActions;
}
export const DecisionStepContext = createContext<DecisionStepContextValue | null>(null);
export function useDecisionStep() {
  const ctx = useContext(DecisionStepContext);
  if (!ctx) {
    throw new Error("useDecisionStep must be used within a DecisionStep.Root");
  }
  return ctx;
}
export function useOptionalDecisionStep() {
  return useContext(DecisionStepContext);
}